import { mab100ArtworkItem } from '~/schemas/common'
import { sanityClientCdn } from '~/services/sanity'
import { getRomeoToken } from '~/utils/getRomeoToken'

export const getMAB100IndexFromRomeo = async (
  lang: string
): Promise<{ data: any }> => {
  let demandData: any = {}

  const baseUrl = process.env.ROMEO_VAULT_URL
  const romeoUrl = `${baseUrl}/report/api/mab100/?d=true`

  const apiUsername = process.env.ROMEO_USER
  const apiPassword = process.env.ROMEO_PASSWORD

  try {
    // Reuse a cached Romeo token where possible. Shares the same cache key as
    // the other server-side call sites since the credentials match.
    const access = await getRomeoToken({
      baseUrl: baseUrl as string,
      username: apiUsername as string,
      password: apiPassword as string,
    })
    const romeoQuery = await fetch(romeoUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${access}`,
      },
    })

    if (romeoQuery.status === 200) {
      const data = (await romeoQuery.json()) as any

      const extractArtworkIds = (
        array: { artwork_id: number; aagr: number; gbp_hammer: number }[]
      ) => {
        const artworkIds: { id: string; aagr: number; gbp_hammer: number }[] =
          []
        array
          .filter(item => item.gbp_hammer !== null)
          .sort((a, b) => b.gbp_hammer - a.gbp_hammer)
          .map(
            (item: {
              artwork_id: number
              aagr: number
              gbp_hammer: number
            }) => {
              artworkIds.push({
                id: `aw-${item.artwork_id}`,
                aagr: item.aagr,
                gbp_hammer: item.gbp_hammer,
              })
            }
          )
        return artworkIds
      }

      const allArtworkIds = [...extractArtworkIds(data.artworks)].slice(0, 100)

      const sanityArtworks = await sanityClientCdn.fetch(mab100ArtworkItem, {
        artworkIds: allArtworkIds.map(item => item.id),
        lang,
      })

      demandData = data
      demandData['sanityArtworks'] = allArtworkIds
        .map((artworkIdItem, rank) => {
          const sanityArtwork = sanityArtworks.find(
            (item: any) => item._id === artworkIdItem.id
          )

          if (!sanityArtwork) return null

          return {
            ...sanityArtwork,
            aagr: artworkIdItem.aagr,
            rank: rank + 1,
          }
        })
        .filter(Boolean)
      delete demandData['artworks']
    }
  } catch (err) {
    console.log('Error', err)
  }

  const dataItem = {
    data: demandData,
  }

  return dataItem ?? { data: {} }
}
